import { React, useState, useEffect, useRef, useContext } from "react";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../../AppStore';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import BOMSelectModal from "../../../../modal/PC/common/BOMSelectModal";
import ItemSelectModal from "../../../../modal/PC/common/ItemSelectModal";
import UserSelectModal from "../../../../modal/PC/common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";
import { AssistWalkerTwoTone, CatchingPokemonSharp } from "@mui/icons-material";
import { IoMdReturnLeft } from "react-icons/io";

let newFileID = 1;
let realFiles = [];
function TAB_ProduceWorkDetail({ title, onClose, id, originRows, userTypeModalOption, qualityYnModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const itemApiRef = useGridApiRef();
  const lotApiRef = useGridApiRef();
  const createlotApiRef = useGridApiRef();
  const userApiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [createlotRows, setCreateLotRows] = useState([]);
  const [createlotColumns, setCreateLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    produce_work_id: null,
    produce_work_number: '',
    produce_work_bom_id: 0,
    produce_work_bom_name: '',
    produce_work_item_id: 0,
    produce_work_item_name: '',
    produce_work_item_type_name: '',
    produce_work_item_division_name: '',
    produce_work_item_spec: '',
    produce_work_start_datetime: '',
    produce_work_end_datetime: '',
    produce_work_count: 0,
    produce_work_complete_count: 0,
    produce_work_error_count: 0,
    produce_work_bigo: '',
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectBOMModalOpen, setSelectBOMModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  // 빠른 입력 처리용 디바운스/시퀀스
  const lotDebounceRef = useRef(null);
  const lotCalcSeqRef = useRef(0);
  // 생산 LotNo 시작번호(일자별)
  const [createLotNoStartNumber, setCreateLotNoStartNumber] = useState('1');


  const handleInitSelect = () => {
    setItemRows([]);
    setLotRows([]);
    setCreateLotRows([]);
    setUserRows([]);
    setFileRows([]);

    setInputs({
      produce_work_id: originRows[0].produce_work_id,
      produce_work_number: originRows[0].produce_work_number,
      produce_work_bom_id: originRows[0].produce_work_bom_id,
      produce_work_bom_name: originRows[0].produce_work_bom_name,
      produce_work_item_id: originRows[0].produce_work_item_id,
      produce_work_item_name: originRows[0].produce_work_item_name,
      produce_work_item_type_name: originRows[0].item_type_name,
      produce_work_item_division_name: originRows[0].item_division_name,
      produce_work_item_spec: originRows[0].produce_work_item_spec,
      produce_work_start_datetime: originRows[0].produce_work_start_datetime === undefined? '':Moment(originRows[0].produce_work_start_datetime).format('YYYY-MM-DDTHH:mm:ss'),
      produce_work_end_datetime: originRows[0].produce_work_end_datetime === undefined?'':Moment(originRows[0].produce_work_end_datetime).format('YYYY-MM-DDTHH:mm:ss'),
      produce_work_count: originRows[0].produce_work_count,
      produce_work_complete_count: originRows[0].produce_work_complete_count,
      produce_work_error_count: originRows[0].produce_work_error_count,
      produce_work_bigo: originRows[0].produce_work_bigo
    });

    var itemData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.produce_work_input_item_seq !== 'undefined' && item.produce_work_input_item_seq === item2.produce_work_input_item_seq;
        }) === index
      );
    });

    setItemRows(itemData.map((item, index) => ({
      id: item.produce_work_input_item_seq,
      produce_work_item_id: item.produce_work_input_item_id,
      produce_work_item_name: item.produce_work_input_item_name,
      produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.produce_work_input_item_spec, item.produce_work_input_item_width, item.produce_work_input_item_height, item.produce_work_input_item_depth),
      produce_work_item_count: item.produce_work_input_item_count,
      produce_work_quality_exam_yn: 'N',
      produce_work_item_bigo: item.produce_work_input_item_bigo,
    })));
    
    
    var userData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.produce_work_user_seq !== 'undefined' && item.produce_work_user_seq === item2.produce_work_user_seq;
        }) === index
      );
    });

    setUserRows(userData.map((item, index) => ({
      id: item.produce_work_user_seq,
      produce_work_user_id: item.produce_work_user_id,
      produce_work_user_name: item.produce_work_user_name,
      produce_work_user_dept_name: item.produce_work_user_dept_name,
      produce_work_user_position_name: item.produce_work_user_position_name,
      produce_work_user_type: item.produce_work_user_type,
      produce_work_user_bigo: item.produce_work_user_bigo,
    })));

    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.produce_work_file_id !== 'undefined' && item.produce_work_file_id === item2.produce_work_file_id;
        }) === index
      );
    });

    setFileRows(fileData.map((item, index) => ({
      id: item.produce_work_file_id,
      file_name_sever: item.produce_work_file_name_sever,
      file_size: item.produce_work_file_size,
      file_type: item.produce_work_file_type,
      file_extension: item.produce_work_file_extension,
      file_name: item.produce_work_file_name,
      file_type_name: item.produce_work_file_type_name,
      file_size_dp: item.produce_work_file_size_dp,
      reg_user_name: item.produce_work_file_user_name,
      reg_datetime: Moment(item.produce_work_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
    axios.get('/api/p/ProduceWork/CreateItemLotList',
        {
        params : {
          produce_work_id : id
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      if(response.data.length > 0){

        var createLotData = (response.data).filter((item, index) => {
          return (
            (response.data).findIndex((item2, index2) => {
              return typeof item.lot_produce_work_item_lot_seq !== 'undefined' && item.lot_produce_work_item_lot_seq === item2.lot_produce_work_item_lot_seq;
            }) === index
          );
        });

        setCreateLotRows(createLotData.map((item, index) => ({
          id: item.lot_produce_work_item_lot_seq,
          lot_no: item.lot_produce_work_item_lotno,
          lot_create_produce_work_item_id: item.lot_produce_work_item_id,
          lot_create_produce_work_item_name: item.lot_produce_work_item_name,
          lot_create_produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_produce_work_item_spec, item.lot_produce_work_item_width, item.lot_produce_work_item_height, item.lot_produce_work_item_depth),
          lot_create_produce_work_quality_exam_yn: item.produce_work_quality_exam_yn,
          lot_create_produce_work_save_workplace_name: item.lot_produce_work_save_workplace_name,
          lot_create_produce_work_save_warehouse_name: item.lot_produce_work_save_warehouse_name,
          lot_create_produce_work_save_section_name: item.lot_produce_work_save_section_name
        })));
      }

      axios.get('/api/p/ProduceWork/UseItemLotList',
          {
          params : {
            produce_work_id : id
          }
        },
        { withCredentials: true }
      )
      .then((response) => {
        if(response.data.length > 0){
          var useLotData = (response.data).filter((item, index) => {
            return (
              (response.data).findIndex((item2, index2) => {
                return typeof item.lot_produce_work_use_item_lot_seq !== 'undefined' && item.lot_produce_work_use_item_lot_seq === item2.lot_produce_work_use_item_lot_seq;
              }) === index
            );
          });

          setLotRows(useLotData.map((item, index) => ({
            id: item.lot_produce_work_use_item_lot_seq,
            lot_no: item.lot_produce_work_use_item_lotno,
            lot_produce_work_item_id: item.lot_produce_work_use_item_id,
            lot_produce_work_item_name: item.lot_produce_work_use_item_name,
            lot_produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_produce_work_use_item_spec, item.lot_produce_work_use_item_width, item.lot_produce_work_use_item_height, item.lot_produce_work_use_item_depth),
            lot_produce_work_quality_exam_yn: item.produce_work_use_quality_exam_yn,
            lot_produce_work_save_workplace_name: item.lot_produce_work_use_save_workplace_name,
            lot_produce_work_save_warehouse_name: item.lot_produce_work_use_save_warehouse_name,
            lot_produce_work_save_section_name: item.lot_produce_work_use_save_section_name
          })));
          
        }
      })
      .catch((error) => {
          appStore.capture();
      });
    })
    .catch((error) => {
        appStore.capture();
    });

  };

  const handleSetting = () => {
    setItemColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_item_id', headerName: 'produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'produce_work_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
      { field: 'produce_work_item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
      { field: 'produce_work_item_count', headerName: '사용수량', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 100, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'produce_work_item_bigo', headerName: '비고', width: 300, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_item_id', headerName: 'lot_produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_produce_work_save_workplace_id', headerName: 'lot_produce_work_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_produce_work_save_workplace_name', headerName: '사업장',width: 120, headerAlign: 'center'},
      { field: 'lot_produce_work_save_warehouse_id', headerName: 'lot_produce_work_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_produce_work_save_warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_produce_work_save_section_id', headerName: 'lot_produce_work_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_produce_work_save_section_name', headerName: '구역',width: 120, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setCreateLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_item_id', headerName: 'lot_create_produce_work_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_create_produce_work_save_workplace_id', headerName: 'lot_create_produce_work_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_workplace_name', headerName: '사업장',width: 120, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_warehouse_id', headerName: 'lot_create_produce_work_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_create_produce_work_save_warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_create_produce_work_save_section_id', headerName: 'lot_create_produce_work_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_create_produce_work_save_section_name', headerName: '구역',width: 120, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_user_id', headerName: 'produce_work_user_id', width: 0, headerAlign: 'center' },
      { field: 'produce_work_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'produce_work_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      produce_work_item_id: false,
      produce_work_item_name: true,
      produce_work_item_spec: false,
      produce_work_item_count: true,
      produce_work_quality_exam_yn: false,
      produce_work_item_bigo: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_produce_work_item_id: false,
      lot_produce_work_item_name: true,
      lot_produce_work_item_spec: false,
      lot_produce_work_quality_exam_yn: false,
      lot_produce_work_save_workplace_id: false,
      lot_produce_work_save_workplace_name: true,
      lot_produce_work_save_warehouse_id: false,
      lot_produce_work_save_warehouse_name: true,
      lot_produce_work_save_section_id: false,
      lot_produce_work_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setCreateLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_create_produce_work_item_id: false,
      lot_create_produce_work_item_name: true,
      lot_create_produce_work_item_spec: false,
      lot_create_produce_work_quality_exam_yn: false,
      lot_create_produce_work_save_workplace_id: false,
      lot_create_produce_work_save_workplace_name: true,
      lot_create_produce_work_save_warehouse_id: false,
      lot_create_produce_work_save_warehouse_name: true,
      lot_create_produce_work_save_section_id: false,
      lot_create_produce_work_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: true,
      produce_work_user_id: false,
      produce_work_user_name: true,
      produce_work_user_dept_name: true,
      produce_work_user_position_name: true,
      produce_work_user_type: true,
      produce_work_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    produce_work_item_id: false,
    produce_work_item_name: true,
    produce_work_item_spec: false,
    produce_work_item_count: true,
    produce_work_quality_exam_yn: true,
    produce_work_item_bigo: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_produce_work_item_id: false,
    lot_produce_work_item_name: true,
    lot_produce_work_item_spec: false,
    lot_produce_work_quality_exam_yn: true,
    lot_produce_work_save_workplace_id: false,
    lot_produce_work_save_workplace_name: true,
    lot_produce_work_save_warehouse_id: false,
    lot_produce_work_save_warehouse_name: true,
    lot_produce_work_save_section_id: false,
    lot_produce_work_save_section_name: true,
    row_type: false,
    update_type: false
  });

  
  const [createlotColumnVisibilityModel, setCreateLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_create_produce_work_item_id: false,
    lot_create_produce_work_item_name: true,
    lot_create_produce_work_item_spec: false,
    lot_create_produce_work_quality_exam_yn: false,
    lot_create_produce_work_save_workplace_id: false,
    lot_create_produce_work_save_workplace_name: true,
    lot_create_produce_work_save_warehouse_id: false,
    lot_create_produce_work_save_warehouse_name: true,
    lot_create_produce_work_save_section_id: false,
    lot_create_produce_work_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    produce_work_user_id: false,
    produce_work_user_name: true,
    produce_work_user_dept_name: true,
    produce_work_user_position_name: true,
    produce_work_user_type: true,
    produce_work_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [id]);

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };
  
  const handleOnCellClick = (params) => {
    if(params.field === 'produce_work_item_name' || params.field === 'produce_work_item_spec' ){
      setSelectModalTitle('품목 목록');
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        produce_work_item_id: params.row.produce_work_item_id,
        produce_work_item_name: params.row.produce_work_item_name,
        produce_work_item_spec: params.row.produce_work_item_spec,
        produce_work_item_count: params.row.produce_work_item_count,
        produce_work_quality_exam_yn: params.row.produce_work_quality_exam_yn,
        produce_work_item_bigo: params.row.produce_work_item_bigo,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'produce_work_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        produce_work_user_id: params.row.produce_work_user_id,
        produce_work_user_name: params.row.produce_work_user_name,
        produce_work_user_dept_name: params.row.produce_work_user_dept_name,
        produce_work_user_position_name: params.row.produce_work_user_position_name,
        produce_work_user_type: params.row.produce_work_user_type,
        produce_work_user_bigo: params.row.produce_work_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    //생산작업처 모달에서 클릭한 값으로 생산작업처 및 담당자 데이터 설정함.
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["produce_work_partner_id"]: object.id,
        ["produce_work_partner_name"]: object.partner_name,
        ["produce_work_partner_manager"]: partner_user_name,
        ["produce_work_partner_manager_phone"]: partner_user_phone,
        ["produce_work_partner_manager_mail"]: partner_user_email,
        ["produce_work_partner_delivery_post"]: partner_delivery_post,
        ["produce_work_partner_delivery_address"]: partner_delivery_address,
        ["produce_work_partner_delivery_address_add"]: partner_delivery_address_add,
    };
    setInputs(nextInputs);
  };
  
  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const fRow = { display: 'flex', gap: '30px' };
  const fCell = { display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 };
  const fLabel = { width: '120px', flexShrink: 0, fontWeight: 'bold', fontSize: '15px', color: '#333', whiteSpace: 'nowrap' };
  const fInput = { flex: 1, minWidth: 0, height: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '0 12px', fontSize: '15px', boxSizing: 'border-box' };

  return (
    <TabContext value={tabID}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fafafa', minHeight: '50px', paddingRight: '20px' }}>
          <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="정보" value="1" />
                <Tab label="품목" value="2" />
                <Tab label="사용Lot" value="3" />
                <Tab label="생산Lot" value="4" />
                <Tab label="담당자" value="5" />
                <Tab label="파일" value="6" />
          </TabList>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    
                    
                    
                  </div>
        </Box>
        <div ref={tabPanelRef} style={{ flex: 1, overflow: 'hidden', backgroundColor: '#fff', minHeight: 0 }}>
          <TabPanel value="1" style={{ height: '100%', overflow: 'auto', padding: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '28px 34px', boxSizing: 'border-box', width: '100%' }}><div style={fRow}><div style={fCell}><label style={fLabel}>생산작업번호</label><input type="text" placeholder="생산작업번호" value={inputs.produce_work_number} name="produce_work_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div><div style={fCell}><label style={fLabel}>BOM</label><input type="text" placeholder="BOM" value={inputs.produce_work_bom_name} name="produce_work_bom_name" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#f5f5f5' }} readOnly /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>품목</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="text" placeholder="품목명" value={inputs.produce_work_item_name} name="produce_work_item_name" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#f5f5f5' }} readOnly /><input type="text" placeholder="유형" value={inputs.produce_work_item_type_name} name="produce_work_item_type_name" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#f5f5f5' }} readOnly /><input type="text" placeholder="구분" value={inputs.produce_work_item_division_name} name="produce_work_item_division_name" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#f5f5f5' }} readOnly /><input type="text" placeholder="규격" value={inputs.produce_work_item_spec} name="produce_work_item_spec" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#f5f5f5' }} readOnly /></div></div><div style={fRow}><div style={fCell}><label style={fLabel}>생산시작일시</label><input type="datetime-local" value={inputs.produce_work_start_datetime} name="produce_work_start_datetime" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /></div><div style={fCell}><label style={fLabel}>생산종료일시</label><input type="datetime-local" value={inputs.produce_work_end_datetime} name="produce_work_end_datetime" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>생산작업수량</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="number" value={inputs.produce_work_count} name="produce_work_count" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /><input type="number" value={inputs.produce_work_complete_count} name="produce_work_complete_count" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /><input type="number" value={inputs.produce_work_error_count} name="produce_work_error_count" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /></div></div><div style={{ display: 'flex', alignItems: 'flex-start' }}><label style={{ ...fLabel, marginTop: '10px' }}>비고</label><textarea placeholder="비고" name="produce_work_bigo" value={inputs.produce_work_bigo} onChange={(e) => onChange(e) } style={{ flex: 1, minWidth: 0, height: '110px', border: '1px solid #ccc', borderRadius: '4px', padding: '10px 12px', fontSize: '15px', resize: 'none', boxSizing: 'border-box' }} autoComplete="off"></textarea></div></div>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={itemApiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={lotApiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={createlotApiRef}
                  rows={createlotRows}
                  columns={createlotColumns}
                  columnVisibilityModel={createlotColumnVisibilityModel}
                  editMode='cell'  
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={userApiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="6" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </div>
        </div>
    </TabContext>
  );
}

export default TAB_ProduceWorkDetail;